import React from 'react';
import './AlertModal.css';

/**
 * Простая модалка: затемнённый фон, текст, одна кнопка закрытия.
 */
export default function AlertModal({ title = 'Внимание', message, confirmLabel = 'Понятно', onClose }) {
  return (
    <div
      className="alert-modal__backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="alert-modal-title"
    >
      <div className="alert-modal__panel" onClick={(e) => e.stopPropagation()}>
        <h2 id="alert-modal-title" className="alert-modal__title">
          {title}
        </h2>
        <p className="alert-modal__message">{message}</p>
        <button type="button" className="alert-modal__btn" onClick={onClose}>
          {confirmLabel}
        </button>
      </div>
    </div>
  );
}
